export default __webpack_public_path__ + "assets/9f4dc18e94b4e0b094044e160508a9e4.png";